import React, { useEffect, useRef, useState } from "react";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { withRouter  } from 'react-router-dom';
import 'moment/locale/ru';
import { styles } from "../../../containers/goods/styles";
import Loader from "../../utils/Loader";
import { parseNumToFixed, roundToFixed } from "../../../utils/common";
import { useOnClickOutside } from "../../../hooks";
import swal from 'sweetalert';
import { UpdatePayment } from "../../../pages/accounting/invoice/UpdatePayment";
import request from "../../../action/utils/request";
import { urls } from "../../../constants/app";
import { fetchArticleCash } from "../../../action/handbook";
import { updateWithPayment } from "../../../action/cassa";
import { fetchRevenueStaff, fetchWageFundData } from "../../../action/wageFund";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import ru from "date-fns/locale/ru";
registerLocale("ru", ru);

function ModalDetailData({ nextId, setDetailData, loading, detail, onClose }) {
    const ref = useRef();

    const initData = {
        id: nextId,
        name: null,
        sum: 0,
        payment: false,
        typeCalculate: 'handle',
    };

    const { type, isEdit, index, totalSum, ...item } = detail;

    const [data, setData] = useState(isEdit && !isEmpty(item) ? item : initData);

    const renderTitle = () => {
        if (type === 'payrolls') {
            if (isEdit) return 'Редактирование начисления';
            return 'Добавление начисления';
        }
        if (isEdit) return 'Редактирование выплаты';
        return 'Добавление выплаты';
    }

    useOnClickOutside(ref, () => onClose());

    const onChangeInput = (field) => (e) => {
        const updated = {...data};
        updated[field] = e.target.value;
        setData(updated);
    }

    const onChangeNumberInput = (field) => (e) => {
        const updated = {...data};
        updated[field] = parseNumToFixed(e);
        setData(updated);
    }

    const onSubmit = () => {
        setDetailData(type, data, index);
        onClose();
    }

    return (
        <>
        <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>
          <div  className="modal fade show" style={{ display: 'block' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
              <div ref={ref} className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{renderTitle()}</h5>
                  <button onClick={() => onClose()} type="button" className="close">
                  </button>
                </div>
                <div className="modal-body">
                    <div className="form-group">
                      <label className="form-control-label">Название *</label>
                      <input disabled={loading} type="text" value={data.name} className="form-control" onChange={onChangeInput('name')} />
                    </div>
                    <div className="form-group">
                      <label className="form-control-label">Сумма *</label>
                      <input disabled={loading} type="number" value={data.sum} className="form-control" onChange={(e) => onChangeNumberInput('sum')(e.target.value)} />
                      {totalSum && <span style={{ cursor: 'pointer', color: 'blue' }} onClick={() => onChangeNumberInput('sum')(totalSum)}>{`Остаток: ${totalSum}`}</span>}
                    </div>
                </div>
    
                <div className="modal-footer">
                  <button disabled={loading} type="button" className="btn btn-secondary" onClick={() => onClose()}>Отмена</button>
                  <button
                    onClick={onSubmit}
                    disabled={loading || !data || !data.name || !data.sum}
                    className='btn btn-primary'>
                      Сохранить
                  </button>
                </div>
              </div>
            </div>
        </div>
        </>
    );
}

function ModalAutoCalculateDetailData({ nextId, setDetailData, loading, detail, onClose, staffId, startOfMonthDate, isNotNumber }) {
    const loadingStaff = useSelector(state => state.loaders.revenuestaff);
    const isLoading = loading || loadingStaff;
    
    const ref = useRef();

    const initData = {
        id: nextId,
        name: null,
        sum: 0,
        payment: false,
        typeCalculate: 'auto',
    };

    const { type, isEdit, index, totalSum, ...item } = detail;

    const [data, setData] = useState(isEdit && !isEmpty(item) ? item : initData);
    const [revenueStaff, setRevenueStaff] = useState({ loading: true });
    const [revenueData, setRevenueData] = useState({ loading: true });
    const [dates, setDates] = useState({ 
        start:(data && data.dates && data.dates.start) ? new Date(data.dates.start) : new Date(startOfMonthDate),
        end: (data && data.dates && data.dates.end) ? new Date(data.dates.end) : new Date(moment(startOfMonthDate).endOf('month')),
    });

    const dispatch = useDispatch();

    useEffect(() => {
        const getData = async () => {
            const revenue = await dispatch(fetchRevenueStaff({ staffId, startOfMonthDate }));
            if (revenue && revenue.error) return setRevenueStaff(revenue);
            if (revenue && revenue[0]) {
                const revenueData = await dispatch(fetchWageFundData({ id: revenue[0].revenueId}))
                if (revenueData && !revenueData.error) {
                    setRevenueData(revenueData);
                } else {
                    setRevenueData(null)
                }
                return setRevenueStaff(revenue[0]);
            }
            setRevenueData(null)
            return setRevenueStaff(null)
        }

        if (staffId && startOfMonthDate) {
            getData();
        } else {
            setRevenueStaff(null);
        }
    }, [dispatch, staffId, startOfMonthDate]);

    const renderTitle = () => {
        if (type === 'payrolls') {
            if (isEdit) return 'Редактирование начисления';
            return 'Добавление начисления';
        }
        if (isEdit) return 'Редактирование выплаты';
        return 'Добавление выплаты';
    }

    useEffect(() => {
        if ((revenueStaff && revenueStaff.loading) || (revenueData && revenueData.loading)) return;

        if (revenueStaff && revenueStaff.error) {
            swal({
                title: "Ошибка получения данных из табеля",
                text: 'Автоматический расчет невозможен. ' + (typeof revenueStaff.error === 'string' ? revenueStaff.error : revenueStaff.message || ''),
                icon: "error",
                dangerMode: true,
                button: "Ок",
            }).then(() => onClose());
            return;
        }

        if (isEmpty(revenueStaff)) {
            swal({
                title: "Ошибка получения данных из табеля",
                text: 'Автоматический расчет невозможен. Не найдены данные о сотруднике за выбранный месяц.',
                icon: "error",
                dangerMode: true,
                button: "Ок",
            }).then(() => onClose());
            return;
        }

        const totalMonthSum = calculateSum();
        if (totalMonthSum <= 0) {
            swal({
                title: "Ошибка получения данных из табеля",
                text: 'Автоматический расчет невозможен. Итоговая сумма сотрудника за выбранный месяц меньше или равна 0.',
                icon: "error",
                dangerMode: true,
                button: "Ок",
            }).then(() => onClose());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [revenueStaff]);

    if (isLoading || (revenueStaff && revenueStaff.loading)) {
        return (
            <>
                <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '50%' }}>
                        <div ref={ref} className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{renderTitle()}</h5>
                                <button onClick={() => onClose()} type="button" className="close"></button>
                            </div>
                            <div className="modal-body">
                                <div className='kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid'>
                                    <div style={styles.tableLoading}><Loader text='Загружаю данные'/></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    if (!revenueStaff || revenueStaff.error || isEmpty(revenueStaff)) return null;

    const getDateHours = (item) => {
        if (isEmpty(item) || isEmpty(item.sum)) return 0;
        if (!isNotNumber(item.sum.result)) return parseFloat(item.sum.result);
        if (!isNotNumber(item.sum.plan)) return parseFloat(item.sum.plan);
        return 0;
    }

    const calculateSum = (start, limit) => {
        const getPrize = (index) => {
            if (!revenueStaff || isEmpty(revenueStaff.prize)) return 0;
            const currentDate = moment(startOfMonthDate).add(index, 'days').format('YYYY-MM-DD');
            const filteredPrizes = revenueStaff.prize.filter((prize) => prize.date === currentDate);
            if (isEmpty(filteredPrizes)) return 0;
            return filteredPrizes.reduce((acc, prize) => {
                if (!prize || !prize.sum) return 0;
                if (prize.type === 'depremation') {
                    acc -= +prize.sum
                } else {
                    acc += +prize.sum
                }
                return acc;
            }, 0);
        }

        const getPercentStaff = (staff, index) => {
            if (!staff || isEmpty(staff.revenues)) return 0;
            const staffs = (!isEmpty(revenueData) && !isEmpty(revenueData.revenuesStaff)) ? revenueData.revenuesStaff : [];
    
            const percent = (!isEmpty(revenueData) && !isEmpty(revenueData.revenue) && !isEmpty(revenueData.revenue.percentsPosts)) ? revenueData.revenue.percentsPosts[String(staff.postId)] || 0 : 0;
            if (percent === 0) return 0;
    
            if (isEmpty(staff.revenues[index]) || isEmpty(staff.revenues[index].sum)) return 0;
            if (isNotNumber(staff.revenues[index].sum.result) && isNotNumber(staff.revenues[index].sum.plan)) return 0;
    
            const hours = !isNotNumber(staff.revenues[index].sum.result) ? staff.revenues[index].sum.result : staff.revenues[index].sum.plan;
            if (!hours) return 0;
    
            const postStaffsWork = (staffs || []).filter((entityStaff) => {
                if (entityStaff.postId !== staff.postId) return false;
                if (entityStaff.isDelete || entityStaff.isDeleted) return false;
                if (entityStaff.id === staff.id) return false;
                if (isEmpty(entityStaff.revenues[index])) return false;
                if (!isNotNumber(entityStaff.revenues[index].sum.result) || !isNotNumber(entityStaff.revenues[index].sum.plan)) return true;
                return false;
            });
    
            const postStaffsHours = (postStaffsWork || []).reduce((acc, entityStaff) => {
                if (!isNotNumber(entityStaff.revenues[index].sum.result)) return acc += +entityStaff.revenues[index].sum.result;
                if (!isNotNumber(entityStaff.revenues[index].sum.plan)) return acc += +entityStaff.revenues[index].sum.plan;
                return acc;
            }, 0);
            
            const dataDate = (!isEmpty(revenueData) && !isEmpty(revenueData.revenue) && !isEmpty(revenueData.revenue.revenues)) ? revenueData.revenue.revenues[index] || 0 : 0;
            if (isEmpty(dataDate)) return 0;
    
            const revenueDate = !isNotNumber(dataDate.sum.result) ? dataDate.sum.result : dataDate.sum.plan || 0;
            if (!revenueDate) return 0;

            const allHours = +postStaffsHours + +hours;        
            const allPercent = roundToFixed(revenueDate * (percent / 100));
            const hourPercent = roundToFixed(allPercent / allHours);
            
            if (hours > 0 && revenueDate > 0 && hourPercent > 0) return roundToFixed(hourPercent * hours) || 0;
        }

        const getPrizeRevenueStaff = (staff, index) => {
            if (!staff || isEmpty(staff.revenues)) return 0;
            if (isEmpty(staff.revenues[index]) || isEmpty(staff.revenues[index].sum)) return 0;
            if (isNotNumber(staff.revenues[index].sum.result) && isNotNumber(staff.revenues[index].sum.plan)) return 0;
    
            const fieldPrize = index > 14 ? 'secondPrizeRevenue' : 'firstPrizeRevenue';
            const valuePrize = staff[fieldPrize] || staff.firstPrizeRevenue || 0;
            if (!valuePrize) return 0;
    
            const fieldSum = index > 14 ? 'secondSumRevenuePrize' : 'firstSumRevenuePrize';
            const minSum = staff[fieldSum] || staff.firstSumRevenuePrize || 0;
    
            const hours = !isNotNumber(staff.revenues[index].sum.result) ? staff.revenues[index].sum.result : staff.revenues[index].sum.plan;
            if (!hours) return 0;
    
            const dataDate = (!isEmpty(revenueData) && !isEmpty(revenueData.revenue) && !isEmpty(revenueData.revenue.revenues)) ? revenueData.revenue.revenues[index] || 0 : 0;
            if (isEmpty(dataDate)) return 0;

            const normalShift = (!isEmpty(revenueData) && !isEmpty(revenueData.revenue) && !isNotNumber(revenueData.revenue.normalShift)) ? revenueData.revenue.normalShift : 13;
    
            const revenueDate = !isNotNumber(dataDate.sum.result) ? dataDate.sum.result : dataDate.sum.plan || 0;
            if (!revenueDate || revenueDate < minSum) return 0;
            if (hours >= normalShift) return valuePrize || 0;
            return roundToFixed((valuePrize / normalShift) * hours) || 0;
        }

        return (revenueStaff.revenues || []).reduce((acc, el, index) => {
            if ((start && index < start) || (limit && index > limit)) return acc;
            const hours = getDateHours(el);
            const field = index > 14 ? 'secondRate' : 'firstRate';
            const rate = revenueStaff[field] ? revenueStaff[field] : revenueStaff.firstRate || 0;
            acc += hours * rate;
            const prize = getPrize(index);
            if (prize) acc += +prize;
            const percent = getPercentStaff(revenueStaff, index);
            if (percent) acc += +percent;
            const prizeRevenue = getPrizeRevenueStaff(revenueStaff, index);
            if (prizeRevenue) acc += +prizeRevenue;
            return acc;
        }, 0);
    }

    const calculateSumDates = () => {
        const { start, end } = dates;
        const startIndex = moment(start).date() - 1;
        const endIndex = moment(end).date() - 1;
        return roundToFixed(calculateSum(startIndex, endIndex), 0);
    }    

    if (calculateSum() <= 0) return null;

    const onChangeInput = (field) => (e) => {
        const updated = {...data};
        updated[field] = e.target.value;
        setData(updated);
    }

    const onSubmit = () => {
        const updated = {...data};
        updated.sum = calculateSumDates();
        updated.dates = dates;
        if (updated.sum === 0) return;
        setDetailData(type, updated, index);
        onClose();
    }

    const onChangeDate = (field) => (date) => {
        const updated = { ...dates };
        updated[field] = date;
        setDates(updated);
    }

    return (
        <>
            <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>
            <div className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%' }}>
                    <div ref={ref} className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{renderTitle()}</h5>
                            <button onClick={() => onClose()} type="button" className="close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label className="form-control-label">Название *</label>
                                <input disabled={loading} type="text" value={data.name} className="form-control" onChange={onChangeInput('name')} />
                            </div>
                            <div className="form-group" style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                <div>Период с</div>
                                <DatePicker
                                    placeholderText="Дата от"
                                    selected={dates.start}
                                    onChange={onChangeDate('start')}
                                    className="form-control"
                                    style={{ position: 'absolute', width: '100%' }}
                                    minDate={new Date(startOfMonthDate)}
                                    dateFormat="dd.MM.yyyy"
                                    maxDate={dates.end ? dates.end : new Date(moment(startOfMonthDate).endOf('month'))}
                                    required={true}
                                />
                                <div>по</div>
                                <DatePicker
                                    placeholderText="Дата до"
                                    selected={dates.end}
                                    onChange={onChangeDate('end')}
                                    minDate={dates.start ? dates.start : new Date(startOfMonthDate)}
                                    dateFormat="dd.MM.yyyy"
                                    maxDate={new Date(moment(startOfMonthDate).endOf('month'))}
                                    required={true}
                                    className="form-control"
                                    style={{ position: 'absolute', width: '100%' }}
                                />
                            </div>
                            <div className="form-group">
                                <span style={{ fontWeight: 600, color: '#000' }}>Сумма: {calculateSumDates()}</span>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button disabled={loading} type="button" className="btn btn-secondary" onClick={() => onClose()}>Отмена</button>
                            <button
                                onClick={onSubmit}
                                disabled={loading || !data || !data.name || !dates.start || !dates.end}
                                className='btn btn-primary'>
                                Сохранить
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

function ModalChoice({ choiceType, onClose }) {
    const ref = useRef();

    return (
        <>
        <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>
          <div  className="modal fade show" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
              <div ref={ref} className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Выбор типа внесения</h5>
                  <button onClick={() => onClose()} type="button" className="close">
                  </button>
                </div>
                <div className="modal-body">
                    <div style={{ display: 'flex', gap: '10px'}}>
                        <button className="btn btn-primary" onClick={() => choiceType('handle')}> Ручное </button>
                        <button className="btn btn-primary" onClick={() => choiceType('auto')}> Автоматическое </button>
                    </div>
                </div>
              </div>
            </div>
        </div>
        </>
    );
}

function EditWagesStaff({ data, edit, calculateTotal, onRefresh, setData, setEditWage }) {
    const loadingPoints = useSelector(state => state.loaders.filials);
    const loadingWages = useSelector(state => state.loaders.wages);
    const settings = useSelector(state => state.settings.init);
    const articles = useSelector(state => state.handbook.articlesCash);
    const loading = loadingPoints || loadingWages;
    const [ editDetail, setEditDetail ] = useState(null);
    const [ isModalOpen, setIsModalOpen ] = useState(false);

    const dispatch = useDispatch();

    const isNotNumber = (value) => {
        if (value === null || value === undefined || typeof value === 'boolean') return true;
        if (typeof value === 'number') return isNaN(value) || !isFinite(value);

        if (typeof value === 'string') {
            const trimmed = value.trim();
            if (trimmed === '') return true;
            const num = Number(trimmed);
            return isNaN(num);
        }
    
        return true;
    }

    if (loading) return(
        <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
            <div style={styles.tableLoading}><Loader text='Загружаю данные'/></div>
        </div>
    );

    const initData = { 
        payments: [],
        payrolls: [],
        id: `new_${edit.value}`,
        isChange: true,
        staffId: edit.value,
        wageId: data.id,
        name: edit.name,
        postId: edit.postId,
        pointId: data.pointId,
        startOfMonthDate: data.startOfMonthDate,
    }
    
    const setDetailData = (field, values, index) => {
        if (!field) return;
        if (!data || isEmpty(data)) return;

        if (!isNotNumber(index)) {
            const updated = { ...data };

            let entity;
            if (edit.dataId) entity = (updated.staff || []).find((item) => item.id === edit.dataId);

            if (isEmpty(entity)) {
                entity = initData;
                entity[field][index] = values;
                entity.isChange = true;
                updated.staff = [ ...(updated.staff || []), entity];
                if (!edit.dataId) setEditWage({ ...edit, dataId: entity.id });
                return setData(updated);
            }

            entity[field][index] = values;
            entity.isChange = true;

            updated.staff = updated.staff.map((item) => {
                if (item.id !== edit.dataId) return item;
                return entity;
            });

            return setData(updated);
        }

        if (!isEmpty(values)) {
            const updated = { ...data };

            let entity;
            if (edit.dataId) entity = (updated.staff || []).find((item) => item.id === edit.dataId);

            if (isEmpty(entity)) {
                entity = initData;
                entity[field] = [...(entity[field] || []), values];
                entity.isChange = true;
                updated.staff = [ ...(updated.staff || []), entity];
                if (!edit.dataId) setEditWage({ ...edit, dataId: entity.id });
                return setData(updated);
            }

            entity[field] = [...(entity[field] || []), values];
            entity.isChange = true;
            updated.staff = updated.staff.map((item) => {
                if (item.id !== edit.dataId) return item;
                return entity;
            });

            return setData(updated);    
        }
    }

    const onDeleteData = (field, index) => {
        if (!field) return;
        const updated = { ...data };
        if (isEmpty(updated) || !edit.dataId) return;
        const entity = (updated.staff || []).find((item) => item.id === edit.dataId);
        if (isEmpty(entity)) return;
        const item = entity[field][index];
        if (!item) return;

        if (item.payment && item.payment !== 'none') return swal({
            title: "Удаление невозможно",
            text: 'Выплата оплачена',
            icon: "error",
            dangerMode: true,
            button: "Ок",
        });

        return swal({
            title: "Удаление данных",
            text: `Вы действительно хотите удалить ${field === 'payrolls' ? 'начисление' : 'выплату'} ${item.name || ''} на сумму ${item.sum}`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) {
                entity[field] = entity[field].filter((item, itemIndex) => itemIndex !== index);
                entity.isChange = true;
                updated.staff = updated.staff.map((item) => {
                    if (item.id !== edit.dataId) return item;
                    return entity;
                });
                if (!edit.dataId) setEditWage({ ...edit, dataId: entity.id });
                setData(updated);
            }
        })
    }

    const choiceTypeModal = (value) => {
        if (!isEmpty(editDetail)) setEditDetail({ ...editDetail, modalType: value });
    }

    const setEdit = (item, type, modalType, index) => {
        if (!item && !type) return setEditDetail(null);
        if (isNotNumber(index)) {
            let entity;
            if (edit.dataId) entity = (data.staff || []).find((item) => item.id === edit.dataId);
            if (isEmpty(entity)) entity = initData;
            const detail = { type, modalType }
            let totalSum;
            if (type === 'payments') totalSum = parseNumToFixed(calculateTotal('payrolls', entity) - calculateTotal('payments', entity));
            if (totalSum) detail.totalSum = totalSum;
            return setEditDetail(detail);
        }

        if (item.payment && item.payment !== 'none') return swal({
            title: "Изменение невозможно",
            text: 'Выплата оплачена',
            icon: "error",
            dangerMode: true,
            button: "Ок",
        });

        const detail = {
            ...item,
            type,
            isEdit: true,
            index,
            modalType,
        }
        return setEditDetail(detail);
    }

    const handleSubmitPayment = async (item, index, payment, workingShiftId, refund) => {
        if (!edit.dataId) return;
        const sendedData = JSON.parse(JSON.stringify(data));
        const entityStaff = (sendedData.staff || []).find((staff) => staff.id === edit.dataId );
      
        if (!entityStaff) return;
      
        entityStaff.payments[index] = { ...item, payment: refund ? 'none' : payment };
        entityStaff.isChange = true;
      
        const articlesCash = settings.articlesCash || {};
        const text = refund ? 'Возврат выплаты' : 'Оплата выплаты';
      
        const dataArticle = {
            typeTransaction: payment,
            sum: item.sum,
            name: text,
            notRefunded: true,
            typeMovementCash: refund ? 'income' : 'expenditure',
            wageId: data.id + '_' + edit.value + '_' + item.id,
            movementPay: refund ? 'refund' : 'pay',
            postId: entityStaff.postId ? entityStaff.postId : null,
            comment: 'Сотрудник: ' + edit.name + '. ' + text + (item.name ? ': ' + item.name : '')
        };
      
        if (refund) dataArticle.refund = true;
      
        if (articlesCash.paymentWages) {
            const articleId = parseInt(articlesCash.paymentWages, 10);
            dataArticle.articleId = articleId;
      
            let articleName = null;
            if (articles && articles.length > 0) {
                const entity = articles.find((article) => article.id === articleId);
                if (entity && entity.name) articleName = entity.name;
            }
      
            if (!articleName) {
                const entity = await dispatch(fetchArticleCash(articleId));
                if (entity && entity.name) articleName = entity.name;
            }
        
            if (articleName) dataArticle.name = articleName;
        }
        // } else {
        //     return swal({
        //         title: 'Ошибка сохранения данных',
        //         text: 'Не найдена статья "Оплата выплаты"',
        //         icon: 'error',
        //         dangerMode: true,
        //         button: 'Ок'
        //     });
        // }
      
        try {
            const result = await dispatch(updateWithPayment({ workingShiftId: workingShiftId, article: dataArticle }, sendedData, data.id ));
        
            if (result) {
                setIsModalOpen(false);
                onRefresh();
            }
        } catch (error) {
            const text = [];
            const errorData = error.data || {};
            if (errorData.statusCode) text.push(`Код ошибки: ${errorData.statusCode}`);
            if (errorData.message) text.push(errorData.message);
        
            return swal({
                title: 'Ошибка сохранения данных',
                text: text.join('. '),
                icon: 'error',
                dangerMode: true,
                button: 'Ок'
            });
        }
    };

    const handlePaymentMethod = (item, index) => async (method, refund) => {
        const getWorkingShift = async () => {
            const params = {
                'closed_at_null': true,
                'point.id': data.pointId
            };
            const workingShift = await request({ method: 'get', url: urls.workingShift, params });
            return workingShift;
        }

        const workingShift = await getWorkingShift();
        if (workingShift.length <= 0) return swal({
            title: "Смена закрыта",
            text: "Смена закрыта, оплата невозможна. Откройте смену и повторите попытку.",
            icon: "warning",
            dangerMode: true,
            button: "Ок",
        });

        handleSubmitPayment(item, index, method, workingShift[0].id, refund);
    };

    const getNextId = (field) => {
        if (isEmpty(data)) return 1;
        let entity;
        if (edit.dataId) entity = (data.staff || []).find((item) => item.id === edit.dataId);
        if (isEmpty(entity)) entity = initData;
        if (isEmpty(entity) || isEmpty(entity[field])) return 1;
        if (entity[field].length === 0) return 1;
        return entity[field][entity[field].length - 1].id + 1;
    }

    const renderBody = () => {
        let entity;
        if (edit.dataId) entity = (data.staff || []).find((item) => item.id === edit.dataId);
        if (isEmpty(entity)) entity = initData;
        
        return (
            <>
            <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded'>
                <h3 style={{ color: '#000', padding: 10 }}>{edit.name ? edit.name : edit.value}</h3>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: '10px' }}>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <h4 style={{ color: '#000', borderBottom: '1px solid rgb(235, 237, 242)' }}> 
                            Начисления 
                            <button onClick={() => setEdit(null, 'payrolls', 'choice')} className="btn btn-icon btn-success" style={{ scale: '0.7' }}> 
                                <i className="flaticon2-plus"/> 
                            </button> 
                        </h4>
                        <table className='kt-datatable__table'>
                            <thead className='kt-datatable__head'>
                                <tr className='kt-datatable__row'>
                                    <th className='kt-datatable__cell' style={{ fontWeight: 300 }}><span>Наименование</span></th>
                                    <th className='kt-datatable__cell'></th>
                                    <th className='kt-datatable__cell' style={{ fontWeight: 300 }}><span>Сумма</span></th>
                                </tr>
                            </thead>
                            <tbody className='kt-datatable__body'>
                                {entity &&
                                    (entity.payrolls || []).map((item, index) => (
                                        <tr className="kt-datatable__row">
                                            <td style={{ width: 'auto' }}  className="kt-datatable__cell">
                                                <div style={{ display: 'flex', gap: '10px'}}>
                                                    <span style={{ color: 'blue', cursor: 'pointer' }} onClick={() => setEdit(item, 'payrolls', item.typeCalculate || 'handle', index)}>
                                                        {item.name}
                                                    </span>
                                                    <button onClick={() => onDeleteData('payrolls', index)} className="button_order_table">
                                                        <i className="kt-nav__link-icon flaticon2-trash order_table"/>
                                                    </button>
                                                </div>
                                            </td>
                                            <td style={{ width: '30%' }} className="kt-datatable__cell"><span></span></td>
                                            <td style={{ color: '#000', width: '30%' }} className="kt-datatable__cell"><span>{item.sum}</span></td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <h4 style={{ color: '#000', borderBottom: '1px solid rgb(235, 237, 242)' }}> Выплаты 
                            <button onClick={() => setEdit(null, 'payments', 'choice')} className="btn btn-icon btn-success" style={{ scale: '0.7' }}> 
                                <i className="flaticon2-plus"/>
                            </button>
                        </h4>
                        <table className='kt-datatable__table'>
                            <thead className='kt-datatable__head'>
                                <tr className='kt-datatable__row'>
                                    <th className='kt-datatable__cell' style={{ fontWeight: 300 }}><span>Наименование</span></th>
                                    <th className='kt-datatable__cell' style={{ fontWeight: 300 }}>Оплата</th>
                                    <th className='kt-datatable__cell' style={{ fontWeight: 300 }}><span>Сумма</span></th>
                                </tr>
                            </thead>
                            <tbody className='kt-datatable__body'>
                                {entity &&
                                    (entity.payments || []).map((item, index) => (
                                        <tr className="kt-datatable__row">
                                            <td style={{ width: 'auto' }} className="kt-datatable__cell">
                                                <div style={{ display: 'flex', gap: '10px'}}>
                                                    <span style={{ color: 'blue', cursor: 'pointer' }} onClick={() => setEdit(item, 'payments', item.typeCalculate || 'handle', index)}>
                                                        {item.name}
                                                    </span>
                                                    <button onClick={() => onDeleteData('payments', index)} className="button_order_table">
                                                        <i className="kt-nav__link-icon flaticon2-trash order_table"/>
                                                    </button>
                                                </div>
                                            </td>
                                            <td style={{ width: '30%', display: 'flex', alignItems: 'center' }} className="kt-datatable__cell">
                                            {item.payment && item.payment !== 'none' ? (
                                                <>
                                                    <span style={{ marginRight: '8px' }}>Оплачено {item.payment === 'cash' ? 'Наличные' : 'Расчетный счет'}</span>
                                                    <span 
                                                        className="kt-switch kt-switch--sm kt-switch--icon"
                                                        onClick={() => setIsModalOpen(item.id)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={true}
                                                            readOnly
                                                        />
                                                        <span className="new_order_switch"></span>
                                                    </span>
                                                </>
                                            ) : (
                                                <>
                                                    <span style={{ marginRight: '8px' }}>Оплатить из кассы</span>
                                                    <span
                                                        className="kt-switch kt-switch--sm kt-switch--icon"
                                                        onClick={() => setIsModalOpen(item.id)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={false}
                                                            readOnly
                                                        />
                                                        <span className="new_order_switch"></span>
                                                    </span>
                                                </>
                                            )}
                                            <UpdatePayment
                                                isOpen={isModalOpen === item.id}
                                                onClose={() => setIsModalOpen(false)}
                                                totalSum={parseNumToFixed(item.sum) || 0}
                                                onPaymentMethod={handlePaymentMethod(item, index)}
                                                payment={item.payment}
                                            />
                                            </td>
                                            <td style={{ color: '#000', width: '30%' }} className="kt-datatable__cell"><span>{item.sum}</span></td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                <div style={{ display: 'flex', padding: '10px' }}>
                    <table className='kt-datatable__table' style={{ width: '50%' }}>
                        <tbody className='kt-datatable__body'>
                            <tr className="kt-datatable__row">
                                <td style={{ color: '#000', cursor: 'pointer', width: 'auto' }} className="kt-datatable__cell"><span>Итого</span></td>
                                <td style={{ width: '30%' }} className="kt-datatable__cell"></td>
                                <td style={{ color: '#000', width: '30%' }} className="kt-datatable__cell"><span>{calculateTotal('payrolls', entity)}</span></td>
                            </tr>
                        </tbody>
                    </table>
                    <table className='kt-datatable__table' style={{ width: '50%' }}>
                        <tbody className='kt-datatable__body'>
                            <tr className="kt-datatable__row">  
                                <td style={{ color: '#000', width: 'auto' }} className="kt-datatable__cell"><span>Итого</span></td>
                                <td style={{ width: '30%' }} className="kt-datatable__cell"></td>
                                <td style={{ color: '#000', width: '30%' }} className="kt-datatable__cell"><span>{calculateTotal('payments', entity)}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            {!isEmpty(editDetail) && editDetail.modalType === 'choice' && <ModalChoice choiceType={choiceTypeModal} onClose={() => setEdit(null, null, null)}/>}
            {!isEmpty(editDetail) && editDetail.modalType === 'handle' && <ModalDetailData nextId={getNextId(editDetail.type)} setDetailData={setDetailData} onClose={() => setEdit(null, null, null)} loading={loading} detail={editDetail}/>}
            {!isEmpty(editDetail) && editDetail.modalType === 'auto' && <ModalAutoCalculateDetailData isNotNumber={isNotNumber} staffId={edit.value} startOfMonthDate={data.startOfMonthDate} nextId={getNextId(editDetail.type)} setDetailData={setDetailData} onClose={() => setEdit(null, null, null)} loading={loading} detail={editDetail}/>}
            </>
        );
    }

    return renderBody();
}

export default withRouter(EditWagesStaff);